"use strict";

export function initInScope ($scope) {
    $scope.find('.js-newsletter-btn').each(function(index) {
        $(this).on("click", function(){
           $(this).addClass('d-none');
        });
    });
}
